"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facebook = void 0;
const react_1 = __importDefault(require("react"));
const Facebook = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("rect", { width: "50", height: "50", rx: "5", fill: "#5B8DEF" }),
        react_1.default.createElement("path", { d: "M24 28.3333H19V35H24V48H28H32V35H38L39 28.3333H32V25.5C32 23.9083 32.4617 23 34 23H39V15H32.6533C26.66 15 24 17.6383 24 22.6917V28.3333Z", fill: "white" })));
};
exports.Facebook = Facebook;
